import { render } from "./Results.vue?vue&type=template&id=4963a980&scoped=true"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"

import "@/assets/scss/_filter_TEMP.scss?vue&type=style&index=0&id=4963a980&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4963a980"]])

export default __exports__